'use client'

import {ProductGridContext} from '@local/stores/contexts'
import {ProductGridCard, ProductGridCardProps} from './ProductGridCard'
import {ProductGridFilter, ProductGridFilterProps} from './ProductGridFilter'
import {Button, EnquireForm} from '@local/ui/components'
import React, {ReactNode, useContext, useState} from 'react'
import {cx} from '@local/utils/cx'
import {ProductGridProps} from '@local/ui/blocks/productGrid/ProductGrid'

export interface ProductGridFilterWrapperProps {
	items: ProductGridProps['grid']
	filterEnabled?: boolean
	children: ReactNode
	filter: Omit<ProductGridFilterProps, 'onSubmit'>
	calendarNotice?: string
	enquireForm: {
		listID: string
		description: string
		successText: string
		successTitle: string
		retreatList: Array<{label:string, id:string, value:string}>
	}
}

export const ProductGridFilterWrapper = ({children, enquireForm, items, filter, calendarNotice, filterEnabled}:ProductGridFilterWrapperProps) => {
	const {isFilterPanelOpen, setFilterPanel} = useContext(ProductGridContext)
	const [filteredItems, setFilteredItems] = useState<Array<ProductGridCardProps>>([])
	const [isHelpModalOpen, setIsHelpModalOpen] = useState<boolean>(false)
	const handleFilter = (filteredItems) => {
		setFilteredItems(filteredItems)
	}

	return (
		<>
			<div
				className={cx(
					'fixed  top-16 flex items-center lg:top-20 margin-right-1 lg:right-40 z-10 w-fit px-0  lg:!px-24 text-9',
					isFilterPanelOpen && 'mr-[var(--sbw)]',
				)}>
				<Button
					variant='primary'
					small
					className='lg-max:h-34 lg-max:px-8 hidden lg:flex'
					onClick={() => setIsHelpModalOpen(true)}>
					<span className='text-9 tracking-widest'>MAKE AN ENQUIRY</span>
				</Button>
				{filterEnabled && (
					<Button
						variant='secondary'
						small
						className='lg-max:h-34 lg-max:px-8 ml-4'
						onClick={() => setFilterPanel(!isFilterPanelOpen)}>
						<span className='text-9 tracking-widest'>Filter</span>
					</Button>
				)}
			</div>

			{filteredItems?.length
				? (
					<ul
						key='item-list'
						className='grid-container grid grid-cols-2 lg:grid-cols-5 gutter-gap-1 lg:gap-10'>
						{filteredItems.map((item, index) => (
							<ProductGridCard key={`${item.id}-${index}`} {...item} index={index} />
						))}
					</ul>
				)
				: children}
			<ProductGridFilter {...filter} items={items} onSubmit={handleFilter} calendarNotice={calendarNotice} />
			{enquireForm && (
				<EnquireForm {...enquireForm} isOpen={isHelpModalOpen} onClickClose={() => setIsHelpModalOpen(false)} title='MAKE AN ENQUIRY' />
			)}
		</>
	)
}
